import { __makeTemplateObject } from "tslib";
import React from "react";
import { Box, Button, Typography, makeStyles } from "@material-ui/core";
import { alpha } from "@material-ui/core/styles";
import { Add } from "@material-ui/icons";
import styled from "styled-components";
import basic from "../../../colors/basic";
import primary from "../../../colors/primary";
var useStyles = makeStyles(function (theme) { return ({
    addOptionButtonContainer: {
        cursor: "pointer",
        width: "fit-content",
        margin: "10px 0",
        "& button": {
            height: "20px",
            marginRight: "8px",
            minWidth: "20px",
            padding: "0px"
        }
    },
    addOptionLabel: {
        color: alpha(theme.palette.text.primary, 0.6),
        fontSize: "15px",
        fontWeight: 600,
        lineHeight: 1.6
    }
}); });
export var StyledBoxContainer = styled(Box)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tdisplay: flex;\n\talign-items: center;\n\t", "\n"], ["\n\tdisplay: flex;\n\talign-items: center;\n\t", "\n"])), function (_a) {
    var $isDisabled = _a.$isDisabled;
    return ($isDisabled ? "cursor: not-allowed" : "");
});
var ButtonComponent = function (_a) {
    var onClick = _a.onClick, _b = _a.isDisabled, isDisabled = _b === void 0 ? false : _b, label = _a.label;
    var classes = useStyles();
    return (React.createElement(StyledBoxContainer, { className: classes.addOptionButtonContainer, onClick: onClick, "$isDisabled": isDisabled },
        React.createElement(Button, { style: { background: isDisabled ? basic[800] : primary[600], borderRadius: "50%" }, disabled: isDisabled },
            React.createElement(Add, { style: { color: basic[100], fontSize: "18px" } })),
        React.createElement(Typography, { className: classes.addOptionLabel }, label)));
};
export default ButtonComponent;
var templateObject_1;
//# sourceMappingURL=index.js.map